export const privyCleaner = () => {
  const prefix = "privy";
  const localStorageKeys = Object.keys(localStorage).filter((key) => key.startsWith(prefix));
  const sessionStorageKeys = Object.keys(sessionStorage).filter((key) => key.startsWith(prefix));
  if (localStorageKeys.length > 0) localStorageKeys.forEach((key) => localStorage.removeItem(key));

  if (sessionStorageKeys.length > 0)
    sessionStorageKeys.forEach((key) => sessionStorage.removeItem(key));
};
